import React, { useState } from 'react';
import { Paper, Typography, IconButton, Box, Fade } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { format } from 'date-fns';
import InsightfulButton from './InsightfulButton';

const ArticleInfoBox = ({ article }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const maxLength = 200;

    const renderTLDR = (text) => {
        if (!text) return 'No summary available';

        if (text.length <= maxLength) return text;

        if (isExpanded) {
            return (
                <span>
                    {text}
                    <span
                        onClick={() => setIsExpanded(false)}
                        style={{
                            color: '#1976d2',
                            cursor: 'pointer',
                            textDecoration: 'none'
                        }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    >
                        {' '}less
                    </span>
                </span>
            );
        }

        return (
            <span>
                {text.substring(0, maxLength)}...
                <span
                    onClick={() => setIsExpanded(true)}
                    style={{
                        color: '#1976d2',
                        cursor: 'pointer',
                        textDecoration: 'none'
                    }}
                    onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                    onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                >
                    {' '}more
                </span>
            </span>
        );
    };

    return (
        <Fade in={Boolean(article)} timeout={500}>
            <Paper
                elevation={3}
                sx={{
                    p: 1,
                    mt: 2,
                    minHeight: '150px',
                    width: '100%',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    transition: 'all 0.3s ease-in-out'
                }}
            >
                {article ? (
                    <>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}>
                            <Typography
                                variant="h6"
                                component="h6"
                                sx={{
                                    flex: 1,
                                    transition: 'opacity 0.3s ease-in-out'
                                }}
                            >
                                {article.title}
                            </Typography>
                        </Box>

                        <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{
                                display: 'block',
                                transition: 'opacity 0.3s ease-in-out'
                            }}
                        >
                            {article.pubDate ? format(new Date(article.pubDate), 'PPP') : 'Date not available'}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                transition: 'opacity 0.3s ease-in-out',
                                display: 'flex',
                                alignItems: 'baseline'
                            }}
                        >
                            {renderTLDR(article.TLDR)}
                        </Typography>

                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            mt: 1,
                        }}>
                            <InsightfulButton article={article} />
                            <IconButton
                                href={article.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{ ml: 1, p: 0 }}
                            >
                                <OpenInNew />
                                <Typography variant="body2" sx={{ ml: 1 }}>Read article</Typography>
                            </IconButton>

                        </Box>
                    </>
                ) : (
                    <Box sx={{
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <Typography variant="body1" color="text.secondary">
                            Hover over a marker to see article details
                        </Typography>
                    </Box>
                )}
            </Paper>
        </Fade>
    );
};

export default ArticleInfoBox;